var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [("key" + (_vm.name)), 'hold-key', _vm.classes, _vm.keyStateClass],
    attrs: {
      "title": "Hold key"
    }
  }, [_vm.needShiftTarget && !_vm.oneHandedTypingHand ? _c('shift-model-hand', {
    ref: "modelHand",
    attrs: {
      "hand": _vm.holdHand,
      "hide-pulse": _vm.hidePulsingLetter
    }
  }) : _vm._e(), !_vm.needShiftTarget && !_vm.oneHandedTypingHand ? _c('model-hand', {
    ref: "modelHand",
    attrs: {
      "hand": _vm.holdHand,
      "hide-pulse": _vm.hidePulsingLetter
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }